import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgTrash = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "feather feather-trash-2",
	...props,
	children: [
		/* @__PURE__ */ _jsx("polyline", { points: "3 6 5 6 21 6" }),
		/* @__PURE__ */ _jsx("path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" }),
		/* @__PURE__ */ _jsx("line", {
			x1: 10,
			y1: 11,
			x2: 10,
			y2: 17
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 14,
			y1: 11,
			x2: 14,
			y2: 17
		})
	]
});
export default SvgTrash;
